;

          (function(){

            if(window.__ovrevInit) return; window.__ovrevInit=true;

            var s=document.getElementById('ovrev-slider'); if(!s) return;

            var n=s.querySelectorAll('.ovrev-slide').length||3;

            document.querySelectorAll('.ovrev-arrow').forEach(function(b){ b.addEventListener('click',function(){ var cur=Math.round(s.scrollLeft/s.clientWidth); var i=(cur+(+b.getAttribute('data-dir'))+n)%n; s.scrollTo({left:s.clientWidth*i,behavior:'auto'}); }); });

            

             

          })();

          
;

          (function(){

            if(window.__blrmInit) return; window.__blrmInit=true;

            var s=document.getElementById('blrm-slider'); if(!s) return;

            var n=s.querySelectorAll('.blrm-slide').length||3;

            document.querySelectorAll('.blrm-arrow').forEach(function(b){ b.addEventListener('click',function(){ var cur=Math.round(s.scrollLeft/s.clientWidth); var i=(cur+(+b.getAttribute('data-dir'))+n)%n; s.scrollTo({left:s.clientWidth*i,behavior:'auto'}); }); });

          })();

          /* FIX 2026-06-29 (Bliss mobile order, Olivia parity): the review card + Call-an-Expert
             phone (.blrm-wrap) is authored inside the media column so it sits under the gallery on
             desktop. On mobile that makes it render BELOW THE PHOTOS but ABOVE the info accordions.
             Olivia (correct) shows it AFTER the Shipping/What-Arrives/Warranty accordions. This mover
             relocates .blrm-wrap to the end of the product info column on mobile (<=989px) and
             restores it to its original media-column home on desktop. */
          (function(){
            if(window.__blrmMove) return; window.__blrmMove=true;
            function place(){
              var wrap=document.querySelector('.blrm-wrap'); if(!wrap) return;
              var info=document.querySelector('.product__info-container') || document.querySelector('.product__info-wrapper');
              var mobile=window.matchMedia('(max-width:989px)').matches;
              if(mobile){
                if(info && wrap.parentNode!==info){
                  if(!wrap.__home){ wrap.__home=document.createComment('blrm-home'); wrap.parentNode.insertBefore(wrap.__home, wrap); }
                  info.appendChild(wrap);
                }
              } else {
                if(wrap.__home && wrap.__home.parentNode){ wrap.__home.parentNode.insertBefore(wrap, wrap.__home.nextSibling); }
              }
            }
            if(document.readyState!=='loading') place(); else document.addEventListener('DOMContentLoaded', place);
            var t; window.addEventListener('resize', function(){ clearTimeout(t); t=setTimeout(place,200); });
          })();

          
;
                    (function(){
                      var root=document.currentScript&&document.currentScript.previousElementSibling;
                      // currentScript may point past the style; locate the variant-selects robustly
                      function ffInitImgvar(vs){
                      if(!vs||vs.dataset.ffImgvarInit==='1'){return;}
                      if(!vs.querySelector('.ff-imgvar__thumb')){return;}
                      vs.dataset.ffImgvarInit='1';
                      var variants=[];
                      try{var j=vs.querySelector('script[type="application/json"]');if(j){variants=JSON.parse(j.textContent);}}catch(e){variants=[];}
                      var thumbs=Array.prototype.slice.call(vs.querySelectorAll('.ff-imgvar__thumb'));
                      var natives=Array.prototype.slice.call(vs.querySelectorAll('select[data-ffnative]'));
                      var dimLine=vs.querySelector('[data-ffdimline]');
                      var dimColor=vs.querySelector('[data-ffdimcolor]');
                      var ffColorIdx=dimLine?parseInt(dimLine.getAttribute('data-ffcoloridx'),10):-1;
                      var ffDims=[]; var ffCfgIdx=-1;
                      try{ if(dimLine){ ffDims=JSON.parse(dimLine.getAttribute('data-ffdims')||'[]'); ffCfgIdx=parseInt(dimLine.getAttribute('data-ffcfgidx'),10); } }catch(e){}
                      function nativeFor(optIdx){
                        for(var i=0;i<natives.length;i++){if(natives[i].getAttribute('data-ffnative')===String(optIdx)){return natives[i];}}
                        return null;
                      }
                      function currentSelectedValues(){
                        return natives.map(function(s){return s.value;});
                      }
                      function currentVariant(){
                        var vals=currentSelectedValues();
                        for(var i=0;i<variants.length;i++){
                          var ok=true;var opts=variants[i].options||[];
                          for(var k=0;k<vals.length;k++){if(opts[k]!==vals[k]){ok=false;break;}}
                          if(ok){return variants[i];}
                        }
                        return null;
                      }
                      // thumbnail click -> set native select value + dispatch change
                      thumbs.forEach(function(btn){
                        btn.addEventListener('click',function(){
                          var optIdx=btn.getAttribute('data-ffopt');
                          var val=btn.getAttribute('data-ffvalue');
                          var sel=nativeFor(optIdx);
                          if(!sel){return;}
                          if(sel.value!==val){
                            sel.value=val;
                            sel.dispatchEvent(new Event('change',{bubbles:true}));
                          }else{
                            syncUI();
                          }
                        });
                      });
                      function syncUI(){
                        // selected thumbnail + label per option
                        natives.forEach(function(sel){
                          var optIdx=sel.getAttribute('data-ffnative');
                          var val=sel.value;
                          var label=vs.querySelector('[data-ffoptval="'+optIdx+'"]');
                          if(label){label.textContent=val;}
                          thumbs.forEach(function(btn){
                            if(btn.getAttribute('data-ffopt')===optIdx){
                              var on=btn.getAttribute('data-ffvalue')===val;
                              btn.classList.toggle('is-selected',on);
                              btn.setAttribute('aria-selected',on?'true':'false');
                            }
                          });
                        });
                        // dimension line: update the colour (only when multi-colour)
                        var cv=currentVariant();
                        if(cv&&dimColor&&ffColorIdx>=0&&cv.options){dimColor.textContent=cv.options[ffColorIdx];}
                        // Select-line dimensions per configuration
                        if(ffCfgIdx>=0&&ffDims.length){var cfgSel=nativeFor(String(ffCfgIdx));var ci=cfgSel?cfgSel.selectedIndex:-1;var dval=vs.querySelector('[data-ffdimval]');if(dval&&ci>=0&&ci<ffDims.length){dval.textContent=ffDims[ci];}}
                        // Specifications SKU per configuration
                        if(cv&&cv.sku){var skuEl=document.querySelector('[data-ffsku]');if(skuEl){skuEl.textContent=cv.sku;}}
                      }
                      // Re-sync when Dawn updates the variant (change bubbles on variant-selects)
                      vs.addEventListener('change',function(){syncUI();});
                      syncUI();
                      }
                      function ffInitAllImgvar(){Array.prototype.forEach.call(document.querySelectorAll('variant-selects'),ffInitImgvar);}
                      if(document.readyState!=='loading'){ffInitAllImgvar();}else{document.addEventListener('DOMContentLoaded',ffInitAllImgvar);}
                      document.addEventListener('shopify:section:load',ffInitAllImgvar);
                      document.addEventListener('change',function(e){if(e.target&&e.target.matches&&e.target.matches('variant-selects select')){setTimeout(ffInitAllImgvar,250);}});
                    })();
                  
;

              (function(){

                var s=document.currentScript,p=s.previousElementSibling.previousElementSibling,a=p&&p.querySelector(".help-call__pill");

                if(!a)return;

                a.addEventListener("click",function(){

                  (window.dataLayer=window.dataLayer||[]).push({

                    event:"cta_call_click",

                    product:this.dataset.product||"Unknown",

                    variant:this.dataset.variant||"Unknown",

                    phone:(this.querySelector(".help-call__num")||{}).textContent.trim()

                  })

                })

              })();

              
;
(function(){
  function init(){
    if(window.matchMedia && !window.matchMedia('(min-width: 990px)').matches) return;
    var mg=document.querySelector('.product--thumbnail_slider media-gallery');
    if(!mg) return;
    var viewer=mg.querySelector('slider-component:not(.thumbnail-slider)');
    var thumbSlider=mg.querySelector('slider-component.thumbnail-slider');
    if(!viewer) return;
    function thumbBtns(){
      return Array.prototype.slice.call(mg.querySelectorAll('.thumbnail-list__item .thumbnail'))
        .filter(function(b){ return b.offsetParent!==null; });
    }
    if(!viewer.querySelector('.ffgal-arrow')){
      viewer.style.position='relative';
      [['prev','15 18 9 12 15 6'],['next','9 18 15 12 9 6']].forEach(function(d){
        var b=document.createElement('button'); b.type='button';
        b.className='ffgal-arrow ffgal-arrow--'+d[0];
        b.setAttribute('aria-label', d[0]==='prev'?'Previous image':'Next image');
        b.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="#111827" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="'+d[1]+'"></polyline></svg>';
        b.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); go(d[0]); });
        viewer.appendChild(b);
      });
    }
    function activeIndex(btns){
      for(var i=0;i<btns.length;i++){
        var b=btns[i];
        if(b.getAttribute('aria-current')==='true') return i;
        var li=b.closest('.thumbnail-list__item');
        if(li && li.classList.contains('is-active')) return i;
      }
      return 0;
    }
    function go(dir){
      var btns=thumbBtns(); if(!btns.length) return;
      var i=activeIndex(btns);
      var n = dir==='next' ? (i+1)%btns.length : (i-1+btns.length)%btns.length;
      btns[n].click();
      setTimeout(syncArrows, 30);
    }
    function syncArrows(){
      var btns=thumbBtns();
      var show = btns.length>1;
      viewer.querySelectorAll('.ffgal-arrow').forEach(function(a){ a.hidden=!show; });
    }
    // Show at most CAP thumbnails; the rest are reachable via the big-image arrows.
    var CAP = 9;
    function capStrip(){
      var list = thumbSlider && thumbSlider.querySelector('.thumbnail-list');
      var btns = thumbBtns();
      if(!list){ return; }
      // clear any prior badge
      var old = list.querySelector('.ffgal-more');
      if(old && old.parentNode){ old.parentNode.removeChild(old); }
      if(btns.length <= CAP){
        list.style.removeProperty('--ffgal-cap');
        return;
      }
      // cap the visible height to exactly CAP thumbnails (incl. gaps + padding)
      var liA = btns[0].closest('.thumbnail-list__item');
      var liB = btns[1] ? btns[1].closest('.thumbnail-list__item') : null;
      var itemH = liA ? liA.offsetHeight : 78;
      var gap = 9; // matches .9rem gap
      if(liA && liB){ gap = Math.max(0, liB.offsetTop - (liA.offsetTop + liA.offsetHeight)); }
      var pad = 4; // ~.2rem top+bottom padding on the list
      var capH = Math.round(itemH*CAP + gap*(CAP-1) + pad);
      list.style.setProperty('--ffgal-cap', capH + 'px');
      // overlay "+N" on the LAST visible (CAP-th) thumbnail
      var lastVisIdx = CAP - 1;
      var lastLi = btns[lastVisIdx] && btns[lastVisIdx].closest('.thumbnail-list__item');
      if(lastLi){
        var remaining = btns.length - CAP;
        var more = document.createElement('button');
        more.type='button';
        more.className='ffgal-more';
        more.setAttribute('aria-label', remaining + ' more image' + (remaining===1?'':'s'));
        more.textContent = '+' + remaining;
        more.addEventListener('click', function(e){
          e.preventDefault(); e.stopPropagation();
          // jump to the first hidden image and reveal it
          var b = thumbBtns();
          var t = b[CAP];
          if(t){ t.click(); setTimeout(function(){ if(t.closest('.thumbnail-list__item')) t.closest('.thumbnail-list__item').scrollIntoView({block:'nearest'}); syncArrows(); capStrip(); }, 30); }
        });
        lastLi.appendChild(more);
      }
    }
    syncArrows(); capStrip();
    window.addEventListener('resize', function(){ capStrip(); });
    // media-gallery may finish layout slightly later
    [120,400,900].forEach(function(t){ setTimeout(function(){ syncArrows(); capStrip(); }, t); });
  }
  if(document.readyState!=='loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

;
(function(){
  if(window.__ffWarBound)return; window.__ffWarBound=1;
  // document-level CAPTURE so we run before Dawn's <product-form> form-submit handler
  document.addEventListener('submit', function(e){
    var form=e.target;
    if(!form||!form.matches||!form.matches('form[action$="/cart/add"]'))return;
    var cb=document.getElementById('add-extra-product');
    if(!cb||!cb.checked)return;
    var wid=cb.getAttribute('data-product-id'); if(!wid)return;
    e.preventDefault(); e.stopImmediatePropagation();
    var fd=new FormData(form); var mainId=fd.get('id'); var qty=parseInt(fd.get('quantity')||'1',10)||1;
    var btn=form.querySelector('[type="submit"]'); if(btn){btn.setAttribute('aria-disabled','true');btn.classList.add('loading');}
    var drawer=document.querySelector('cart-drawer');
    var body={items:[{id:mainId,quantity:qty},{id:wid,quantity:1}]};
    if(drawer){ body.sections=['cart-drawer','cart-icon-bubble']; body.sections_url=window.location.pathname; }
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
      .then(function(r){return r.json();})
      .then(function(res){
        if(res&&res.status&&!res.items&&res.message){ window.location.href='/cart'; return; }
        if(drawer&&res.sections&&typeof drawer.renderContents==='function'){ drawer.classList.remove('is-empty'); drawer.renderContents(res); if(typeof drawer.open==='function'){drawer.open();} }
        else { window.location.href='/cart'; }
      })
      .catch(function(){ window.location.href='/cart'; })
      .finally(function(){ if(btn){btn.removeAttribute('aria-disabled');btn.classList.remove('loading');} });
  }, true);
})();
